/**
 * Sidebar menu definition — nguồn duy nhất cho tất cả nav items.
 * Server (roles.config.ts) trả về danh sách page keys user được xem;
 * frontend filter menu theo đó.
 */

export interface NavItem {
  key: string;
  label: string;
  path: string;
  icon: string;
  group?: 'main' | 'ops' | 'admin';
}

export const NAV_ITEMS: NavItem[] = [
  { key: 'dashboard', label: 'Bảng điều khiển', path: '/dashboard', icon: 'grid', group: 'main' },
  { key: 'approvals', label: 'Trung tâm phê duyệt', path: '/approvals', icon: 'check-circle', group: 'main' },

  { key: 'payments', label: 'Trung tâm thanh toán', path: '/payments', icon: 'credit-card', group: 'ops' },
  { key: 'cashledger', label: 'Sổ quỹ', path: '/cashledger', icon: 'wallet', group: 'ops' },
  { key: 'ledger', label: 'Sổ cái', path: '/ledger', icon: 'book-open', group: 'ops' },
  { key: 'contracts', label: 'Hợp đồng khách hàng', path: '/contracts', icon: 'file-signature', group: 'ops' },
  { key: 'congnoda', label: 'Công nợ theo dự án', path: '/congnoda', icon: 'kanban', group: 'ops' },
  { key: 'hr', label: 'Lương nhân viên', path: '/hr', icon: 'briefcase', group: 'ops' },
  { key: 'payroll', label: 'Bảng lương', path: '/payroll', icon: 'users', group: 'ops' },
  { key: 'mypayslips', label: 'Phiếu lương của tôi', path: '/mypayslips', icon: 'file-text', group: 'ops' },
  { key: 'assets', label: 'Tài sản cố định', path: '/assets', icon: 'archive', group: 'ops' },
  { key: 'congtacqt', label: 'Quyết toán công tác', path: '/congtacqt', icon: 'receipt', group: 'ops' },
  { key: 'vaynh', label: 'Vay ngân hàng', path: '/vaynh', icon: 'bank-note', group: 'ops' },

  { key: 'reports', label: 'Báo cáo', path: '/reports', icon: 'bar-chart', group: 'admin' },
  { key: 'hopnhat', label: 'Báo cáo hợp nhất', path: '/hopnhat', icon: 'layout-tiles', group: 'admin' },
  { key: 'guide', label: 'Hướng dẫn', path: '/guide', icon: 'help-circle', group: 'admin' },
  { key: 'settings', label: 'Cài đặt', path: '/settings', icon: 'settings', group: 'admin' },
];

/** Filter items theo danh sách page keys server trả về. */
export function filterNav(items: NavItem[], allowedPages: string[] | undefined): NavItem[] {
  if (!allowedPages) return [];
  return items.filter((i) => allowedPages.includes(i.key));
}

/** Group nav items theo group. */
export function groupNav(items: NavItem[]): Array<{ group: string; items: NavItem[] }> {
  const groups: Record<string, NavItem[]> = { main: [], ops: [], admin: [] };
  for (const item of items) {
    (groups[item.group || 'main'] || groups.main).push(item);
  }
  return [
    { group: 'main', items: groups.main },
    { group: 'ops', items: groups.ops },
    { group: 'admin', items: groups.admin },
  ].filter((g) => g.items.length > 0);
}
